'use client'
import type { FC } from 'react'
import styled from 'styled-components'
import { SectionGrid } from './SectionGrid'
import { SectionPricing } from './SectionPricing'
import { SectionSteps } from './SectionSteps'
import type { TypeDevice } from '@/hooks'
import type { TypeCmsHomePage } from '@/schema'
import { duplicateArray } from '@/utils/duplicateArr'
import { SectionTabPhotobooks } from './SectionTabPhotobooks'
import { SectionTabReels } from './SectionTabReels'

type Props = {
  deviceType?: TypeDevice
  data: {
    packs: TypeCmsHomePage['packs']
    photobooks: TypeCmsHomePage['photobooks']
    reels: TypeCmsHomePage['reels']
  }
}


export const MainContents:FC<Props> = ({ deviceType, data }) => {
  return (
    <Main>
      <SectionGrid />
      {/* <SectionTabs data={{
        photobooks: data?.photobooks?.length < 6 ? duplicateArray(data?.photobooks) : data?.photobooks,
        reels: data?.reels?.length < 6 ? duplicateArray(data?.reels) : data?.reels,
      }} /> */}
      <SectionTabReels data={{
        reels: data?.reels?.length < 6 ? duplicateArray(data?.reels) : data?.reels
      }} />
      <SectionTabPhotobooks data={{
        photobooks: data?.photobooks?.length < 6 ? duplicateArray(data?.photobooks) : data?.photobooks
      }} />
      <SectionPricing data={data?.packs} />
      <SectionSteps deviceType={deviceType}/>
    </Main>
  )
}

const Main = styled.main`
  section {
    &:first-child {
      padding-top: 10px;
    }
  }
`
